

























































import { Component, Vue, Prop} from "vue-property-decorator";
import { Getter ,Action} from "vuex-class";
import getActivityDeadline from '@/common/utils/getActivityDeadline';
import getUrlParam from "@/common/utils/getUrlParam";
import store from "@/store";

@Component({
  components: {
   
  }
})
export default class DistributeTopSection extends Vue {
  @Getter("title") title: any;
  @Getter("section") section!: object;
  @Getter("startTime") startTime: any;
  @Getter("deadline") deadline!: number;
  @Getter("distributeTypeParameter") distributeTypeParameter!: Object;
  @Getter("nickname") nickname!: string;
  @Getter("avatar") avatar!: string;
  @Getter("uid") uid!: string;
  @Getter("hasPay") hasPay!: number;
  @Getter("cancel") cancel!: boolean;
  
  broadcastId: string = (getUrlParam('broadcastId') as string);
  type: string = getUrlParam("type") as string;
  cutdownBackground: string = "https://image.xiaomaiketang.com/xm/xwwkEzBXJZ.png";
  cutdownTextColor:string = "#FF393B";
  cutdownTimeColor:string = "#FF393A";
  interval:any = {};
  activityStatus:string="noStart";
  deadlineDay:number = 0;
  deadlineHour:number|string= '00';
  deadlineMinute:number|string= '00';
  deadlineSecond:number|string= '00';
  deadlineMillisecond:number|string='00';
  mounted(){
    this.interval = setInterval(()=>{
      this.getActivityStatus();
      this.getDeadlineDay();
      this.getDeadlineHour();
      this.getDeadlineMinute();
      this.getDeadlineSecond();
      this.getDeadlineMillisecond();
    },50)
  }
  getActivityStatus(){
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if(activityStartTime > nowTimestamp){
      this.cutdownBackground = "https://image.xiaomaiketang.com/xm/xwwkEzBXJZ.png";
      this.cutdownTextColor= "#FF812A";
      this.cutdownTimeColor = "#FF812A";
      this.activityStatus = "noStart"
    }else{
      if(nowTimestamp<activityDeadline){
        this.cutdownBackground = "https://image.xiaomaiketang.com/xm/2KeEMyCkTa.png";
        this.cutdownTextColor= "#FF393B";
        this.cutdownTimeColor = "#FF393A";
        this.activityStatus = "startIng";
      }else{
        this.cutdownBackground = "https://image.xiaomaiketang.com/xm/57Dd6dyjhs.png";
        this.cutdownTextColor= "#676E78";
        this.cutdownTimeColor = "#999";
        this.activityStatus = "endIng";
      }
    }
  }

  // 剩余天数
  getDeadlineDay(){
    if(this.activityStatus === "noStart"){
      this.deadlineDay = getActivityDeadline(this.startTime).deadlineDay;
    }else{
      this.deadlineDay = getActivityDeadline(this.deadline).deadlineDay;
    }
  }
  // 剩余小时
  getDeadlineHour(){
    if(this.activityStatus === "noStart"){
      this.deadlineHour = getActivityDeadline(this.startTime).deadlineHour;
    }else{
      this.deadlineHour = getActivityDeadline(this.deadline).deadlineHour;
    }
  }
  // 剩余分钟
  getDeadlineMinute(){
    if(this.activityStatus === "noStart"){
      this.deadlineMinute = getActivityDeadline(this.startTime).deadlineMinute;
    }else{
      this.deadlineMinute = getActivityDeadline(this.deadline).deadlineMinute;
    }
  }
  // 剩余秒
  getDeadlineSecond(){
    if(this.activityStatus === "noStart"){
      this.deadlineSecond=getActivityDeadline(this.startTime).deadlineSecond;
    }else{
     this.deadlineSecond = getActivityDeadline(this.deadline).deadlineSecond;
    }
  }
  // 剩余毫秒
  getDeadlineMillisecond(){
    if(this.activityStatus === "noStart"){
      this.deadlineMillisecond=getActivityDeadline(this.startTime).deadlineMillisecond;
    }else{
     this.deadlineMillisecond = getActivityDeadline(this.deadline).deadlineMillisecond;
    }
  }
  toInvite(){
    if(this.activityStatus === 'noStart'){
      Vue.$toast.info("活动未开始");
    }else{
      const broadcastId = getUrlParam("broadcastId");
      const distributorId = getUrlParam("distributorId");
      const scene = `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}`+ (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`)+ (this.uid ? `&parentUid=${this.uid}` : `&parentUid=`);
      if (window.__wxjs_environment === 'miniprogram'){
        window.wx.miniProgram.navigateTo({
          url: `/pages/poster/index?${scene}`
        });
      }
    }
  }
  getdecimal(price:any){
    let subData = (Number(price)- parseInt(price)).toFixed(2)
    let index = subData.lastIndexOf(".");
    let subBack = subData.substring(index + 1,subData.length); 
    return subBack;
  }
  destroyed(){
    clearInterval(this.interval)
  }
}
